import React from 'react'
import { Modal, Form, Input, Button } from 'antd'

const AvailabilityReasonModal = ({ visible, onCancel, onSubmit, loading }) => {
  const [form] = Form.useForm()

  const handleInternalSubmit = async () => {
    try {
      const values = await form.validateFields()
      onSubmit(values.reason)
      form.resetFields()
    } catch (err) {
      // validation error, do nothing
    }
  }

  return (
    <Modal
      title='Reason for Unavailability'
      visible={visible}
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      footer={null} // remove default footer
      destroyOnClose
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          name='reason'
          label='Reason'
          rules={[{ required: true, message: 'Please provide a reason' }]}
        >
          <Input.TextArea
            style={{ marginBottom: 12 }}
            rows={3}
            placeholder='Enter reason for unavailability'
          />
        </Form.Item>
      </Form>
      <div style={{ textAlign: 'right' }}>
        <Button onClick={onCancel} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button type='primary' onClick={handleInternalSubmit} loading={loading}>
          Submit
        </Button>
      </div>
    </Modal>
  )
}

export default AvailabilityReasonModal
